import { InputWithSignWheelControl } from '@/modules/common/components/input-with-sign-wheel';
import styles from './index.module.sass';
import { useState } from 'react';
import { ButtonMain } from '@/modules/common/components/button';

export const CrossmixingHeader = () => {
    const [profit, setProfit] = useState('0');
    const [qty, setQty] = useState('0');

  return (
    <div className={styles.root}>
      <InputWithSignWheelControl
        className={styles.headInput}
        value={qty}
        setValue={(val) => setQty(val as string)}
        onChange={(val) => setQty(val)}
        label="максимальное количество отображаемых миксов"
        postfix="шт"
      />
      <InputWithSignWheelControl
        className={styles.headInput}
        value={profit}
        setValue={(val) => setProfit(val as string)}
        onChange={(val) => setProfit(val)}
        label="наименьшая отображаемая выгода"
        postfix="₽"
      />
      <ButtonMain className={styles.actionButton} label='использовать' onClick={() => {}}/>
    </div>
  );
};
